import { Component, Input } from '@angular/core';

@Component({
	selector: 'contact-main-reasons',
	templateUrl: './contact-main-reasons.component.html',
	styleUrls: ['./contact-main-reasons.component.scss'],
})
export class ContactMainReasonsComponent {
	@Input() mainReasons: string[];
	constructor() {}
}
